
import { AccountGroupConfig } from './accountgroups/AccountGroupConfig';
import { AccountsAppConfig } from './accounts/AccountsAppConfig';
import { MenuConfig} from './menus/MenuConfig';
import {OrganizationConfig } from './personel-organization/OrganizationConfig';
import { RingGroupsConfig } from './ring-groups/RingGroupConfig';
import { DepartmentsConfig} from './departments/DepartmentsConfig';
import { NationalityAppConfig } from './nationality/NationalsAppConfig';
import { WorksConfig } from './works/WorksConfig';
import { ProvincesConfig } from './provinces/ProvincesConfig';
import { NationsConfig } from './nations/NationsConfig';
import { DistrictsConfig } from './districts/DistrictsConfig';
import { WardsConfig } from './wards/WardsConfig';
import { PatientCategoriesConfig } from './patientCategories/PatientCategoriesConfig';
import { ClinicsConfig } from './clinics/ClinicsConfig';
import { SupplyCategoriesConfig } from './supply-categories/SupplyCategoriesConfig';
import { SuppliesConfig } from './supplies/SuppliesConfig';
import { MedicalServicesConfig } from './medical-services/MedicalServicesConfig';
import { MedicalCategoriesConfig } from './medical-categories/MedicalCategoriesConfig';
import { ServiceOnDemandConfig } from './service-on-demand/ServiceOnDemandConfig';
import { ArticlesConfig } from './articles/ArticleConfig';

export const SettingsConfig = [
    AccountGroupConfig,
    AccountsAppConfig,
    MenuConfig,
    OrganizationConfig,
    RingGroupsConfig,
    DepartmentsConfig,
    NationalityAppConfig,
    WorksConfig,
    ProvincesConfig,
    DistrictsConfig,
    NationsConfig,
    WardsConfig,
    PatientCategoriesConfig,
    ClinicsConfig,
    SupplyCategoriesConfig,
    SuppliesConfig,
    MedicalServicesConfig,
    MedicalCategoriesConfig,
    ServiceOnDemandConfig,
    ArticlesConfig
]
